import axios from 'axios';
import { vueInstance } from '@/main';

export default class LoadingMiddleware {
    
    static config() {
        // Interceptor de requisição: mostrar loading
        axios.interceptors.request.use(
            (config) => {
                // Verifica se a requisição não deve mostrar loading
                if (!config.hideLoading) {
                    vueInstance.$root.vloading?.show?.(config.loadingMessage);
                }
                return config;
            },
            (error) => {
                // Em caso de erro na requisição, esconder loading
                vueInstance.$root.vloading?.hide?.();
                return Promise.reject(error);
            }
        );

        // Interceptor de resposta: esconder loading
        axios.interceptors.response.use(
            (response) => {
                // Esconder loading apenas se a requisição não especificou para manter
                if (!response.config.hideLoading) {
                    vueInstance.$root.vloading?.hide?.();
                }
                return response;
            },
            (error) => {
                // Em caso de erro, sempre esconder loading
                vueInstance.$root.vloading?.hide?.();
                return Promise.reject(error);
            }
        );
    }

    // Método para fazer requisições sem loading
    static withoutLoading(axiosConfig) {
        return {
            ...axiosConfig,
            hideLoading: true
        };
    }

    // Método para fazer requisições com mensagem personalizada
    static withMessage(axiosConfig, message) {
        return {
            ...axiosConfig,
            loadingMessage: message
        };
    }
}